import React from 'react'
import cn from 'classnames'

import Text from './Text'
import Mac from './Mac'
import Icon from './Icon'
import Illustration from './Illustration'
import styles from './Services.module.css'
import config from '../config'

export default () => (
  <div className={styles.container}>
    <div className={cn(styles.header, 'reveal')}>
      <h4>What we do</h4>
    </div>
    <div className={styles.content}>
      <div className={styles.intro}>
        <div className="reveal">
          <h1>Technically<br />Speaking.</h1>
          <Text size="large">
            Great products cannot be found and bought off the shelf. It takes bold ideas, open iterative processes, user awareness and a pinch of engineering magic to create truly great and delightful apps.
          </Text>
          <Text size="large">
            <a href={`mailto:${config.mail}`} className={styles.link}>Hire us</a> to make your next product or let us help you make your existing one better.
          </Text>
        </div>
      </div>
    </div>

    <div className={styles.illustration}>
      <Illustration type="factory" />
    </div>

    <div className={styles.content}>
      <div className={styles.services}>
        <div className={styles.sections}>
          <div className={cn(styles.section, 'reveal-service')}>
            <Mac type="pixel" />
            <h2>Pixel Loving</h2>
            <Text size="medium">
              We have an obligation to deliver a neat experience for all users – in all projects. Pixels help you to understand. Shows you your next task. Tells you when the next bus leaves. Pixel perfection is of great importance and here to stay.
            </Text>
          </div>

          <div className={cn(styles.section, 'reveal-service')}>
            <Mac type="code" />
            <h2>Code Speaking</h2>
            <Text size="medium">
              Things should just work, every time and every where. We all rely on code in most situations nowadays. But we however don’t just rely on it, we breathe it – in most forms anyways.
            </Text>
          </div>

          <div className={cn(styles.section, 'reveal-service')}>
            <Mac type="app" />
            <h2>App Making</h2>
            <Text size="medium">
              When all is said and done, apps are super fun to make. They are such a great proof of when great design and engineering meet – magic happens. That’s also why we love it so much.
            </Text>
          </div>
        </div>

        <div className={cn(styles.social, 'reveal-service')}>
          <h2>Poke Us!</h2>
          <div className={styles.external}>
            <a href={config.twitter}><Icon type="twitter" className={styles.twitter} /></a>
            <a href={config.github}><Icon type="github" className={styles.github} /></a>
            <a href={config.instagram}><Icon type="instagram" className={styles.instagram} /></a>
            <a href={config.dribbble}><Icon type="dribbble" className={styles.dribbble} /></a>
          </div>
          <Text size="small">or the old fashioned way <a href={`mailto:${config.mail}`}>{config.mail}</a></Text>
        </div>
      </div>
    </div>

  </div>
)



// WEBPACK FOOTER //
// ./src/components/Services.js